import { TmapApp } from '@tmap-web-lib/tmap-app-interface';

export const checkStageServerType = async () => {
  const replaceMap = {
    prd: (hostname: string) =>
      hostname
        .split('.')
        .map((str, index) => {
          if (index === 0) {
            return `${str}-rtg`;
          }
          return str;
        })
        .join('.'),
    stg: (hostname: string) =>
      hostname
        .split('.')
        .map((str, index) => {
          if (index === 0) {
            return str.replace('-stg', '-dtg');
          }
          return str;
        })
        .join('.'),
  };

  const appEnv = import.meta.env.VITE_PUBLIC_TARGET;
  if (!(appEnv === 'prd' || appEnv === 'stg')) {
    return;
  }

  const serverType = await Promise.race([
    TmapApp.getUserSetting({ key: 'local.server_type' }),
    new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('[checkStageServerType]: getUserSetting timeout')), 5000)
    ),
  ]);

  if (serverType === 'rtg') {
    const { hostname, href } = window.location;
    const nextHref = href.replace(hostname, replaceMap[appEnv](hostname));
    window.location.replace(nextHref);

    return new Promise(() => {});
  }
};
